<script>
    /**
     * Alert
     */
    import ModalHeader from './ModalHeader.vue';
    import ModalFooter from './ModalFooter';
    import NormalButton from '../widgets/NormalButton.vue';

    export default {
        alias: 'confirm',
        defaultOptions () {
            return {
                title: '通知'
            };
        },
        modalCreated (options) {
            for (let key in options) {
                this[key] = options[key];
            }
        },
        data () {
            return {
                title: '',
                text: '',
                btnText: ['取消', '确定']
            };
        },
        name: 'modal-confirm',
        methods: {
            onConfirm () {
                this.okCallback && this.okCallback();
                this.close();
            },
            onDestroy () {
                this.cancelCallback && this.cancelCallback();
                this.close();
            }
        },
        components: {
            ModalHeader,
            NormalButton,
            ModalFooter
        },
        mounted () {

        }
    };
</script>

<template>
    <div class="normal-modal">
        <modal-header>{{title}}</modal-header>
        <div class="normal-modal__bd" v-html="text"></div>
        <modal-footer>
            <normal-button @click.native="onDestroy();"
                           theme="default"
                           :is-modal="true"
            >{{btnText[0]}}
            </normal-button>
            <normal-button @click.native="onConfirm();"
                           theme="primary"
                           :is-modal="true"
            >{{btnText[1]}}
            </normal-button>
        </modal-footer>
    </div>
</template>

<style lang="less" scoped>

</style>
